<div class="align-items-center flex gap-3">
  <div class="flex flex-column gap-2">
    <div>{{ name() }}</div>
    <div>({{ username() }})</div>
  </div>

  <div>
    <p-avatar
      id="user-avatar"
      icon="pi pi-user"
      class="user-avatar mr-2"
      size="large"
      shape="circle"
      (click)="menu.toggle($event)"></p-avatar>
  </div>
</div>
<p-menu #menu [model]="menuItems" [popup]="true" styleClass="p-menu-overlay mt-1">
  <ng-template pTemplate="end">
    <div class="m-0 p-3">
      <p-button id="logout-button" severity="secondary" label="Logout" (click)="logout()" icon="pi pi-sign-out"
                variant="outlined"></p-button>
    </div>
  </ng-template>
</p-menu>
